// extracted by mini-css-extract-plugin
module.exports = {"basket-children-spacing":"basketList_basket-children-spacing__Zk5Cy"};